/**
 * Paleta de cores do produto, extraída do design system AWS Cloudscape
 * (visual refresh, `@cloudscape-design/components@3.0.1401`).
 *
 * Substitui o `palette` do LeafyGreen: a estrutura de chaves foi mantida
 * (base / light1-3 / dark1-3) para não espalhar renomeações pelo app, mas
 * **os valores vêm da paleta do Cloudscape** — o verde de marca do LeafyGreen
 * saiu do produto e o azul `primary` do Cloudscape é a cor de acento.
 *
 * Escala neutra (Cloudscape `neutral`): 50 #fcfcfd · 100 #f9f9fa · 200 #f3f3f7
 * 250 #ebebf0 · 300 #dedee3 · 350 #c6c6cd · 400 #b4b4bb · 450 #a4a4ad
 * 500 #8c8c94 · 550 #72747e · 600 #656871 · 650 #424650 · 700 #333843
 * 750 #232b37 · 800 #1b232d · 850 #161d26 · 900 #131920 · 950 #0f141a
 */
export const palette = {
  gray: {
    base: '#8c8c94',
    light1: '#f9f9fa',
    light2: '#ebebf0',
    light3: '#f3f3f7',
    dark1: '#656871',
    dark2: '#424650',
    dark3: '#0f141a',
  },
  /** Cloudscape `green`: 50 #effff1 · 400 #00e500 · 500 #2bb534 · 600 #00802f · 900 #00471e */
  green: {
    base: '#00802f',
    light1: '#2bb534',
    light2: '#00e500',
    light3: '#effff1',
    dark1: '#00802f',
    dark2: '#2bb534',
    dark3: '#00471e',
  },
  /** Cloudscape `primary`/`blue`: 50 #f0fbff · 400 #42b4ff · 600 #006ce0 · 700 #004a9e · 900 #002b66 */
  blue: {
    base: '#006ce0',
    light1: '#42b4ff',
    light2: '#006ce0',
    light3: '#f0fbff',
    dark1: '#004a9e',
    dark2: '#002b66',
    dark3: '#001129',
  },
  /** Cloudscape `red`: 50 #fff5f5 · 400 #ff7a7a · 600 #db0000 · 900 #700000 */
  red: {
    base: '#db0000',
    light1: '#ff7a7a',
    light2: '#db0000',
    light3: '#fff5f5',
    dark1: '#700000',
    dark2: '#ff7a7a',
    dark3: '#520000',
  },
  /** Cloudscape `yellow`: 50 #fffef0 · 400 #ffe347 · 500 #fbd332 · 600 #f2b100 · 900 #855900 */
  yellow: {
    base: '#855900',
    light1: '#fbd332',
    light2: '#ffe347',
    light3: '#fffef0',
    dark1: '#573a00',
    dark2: '#f2b100',
    dark3: '#855900',
  },
  /** Cloudscape `purple`: 50 #faf5ff · 100 #f2e5ff · 400 #bf80ff · 600 #962eff · 700 #7300e5 · 800 #5900b2 */
  purple: {
    base: '#7300e5',
    light1: '#bf80ff',
    light2: '#f2e5ff',
    light3: '#faf5ff',
    dark1: '#5900b2',
    dark2: '#962eff',
    dark3: '#300061',
  },
} as const;

export type PaletteColor = keyof typeof palette;
